import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import LinkCell from '../Cells/LinkCell/LinkCell';
import ActionCell from '../Cells/ActionCell/ActionCell';

import useScreenSize from 'hooks/Screen/useScreenSize';
import { SRBMTrapData } from 'api/traps/SRBMTraps/types';

interface SRBMTrapExpandableProps {
  data: SRBMTrapData;
  slug: string;
}
const SRBMTrapExpandable: React.FC<SRBMTrapExpandableProps> = ({ data, slug }) => {
  const { t } = useTranslation();
  const { isNotMobile, isNotTablet, isNotDesktop, isNotLargeDesktop } = useScreenSize();

  return (
    <div className="d-flex w-100 flex-column">
      {isNotMobile && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('TrapTables.Action')}</span>
          </div>
          <div>
            <ActionCell
              qrCodeOptions={{ msg: `Device Serial Number: ${data.serial_number}`, qr_code: data.qr_code }}
              trap={{ pk: data.id, serialNumber: data.serial_number || '' }}
              slug={slug}
            />
          </div>
        </div>
      )}

      {isNotTablet && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('TrapTables.InteractiveMap')}</span>
            <div>
              <LinkCell title={data?.floor_number?.title || 'None'} link="#" icon="ri-treasure-map-line" />
            </div>
          </div>
        </div>
      )}

      <div className="d-flex flex-column gap-2 justify-content-start my-2">
        {isNotDesktop && (
          <>
            <div>
              <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.Type')}: `}</span> {data.trap_type}
            </div>
          </>
        )}
        {isNotLargeDesktop && (
          <>
            <div>
              <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.SerialNumber')}: `}</span> {data.serial_number}
            </div>
            <div>
              <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.LastConnection')}: `}</span>
              {dayjs(data.last_connect).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')
                ? dayjs(data.last_connect).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')
                : '-'}
            </div>
            <div>
              <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.DateOfInstallation')}: `}</span>
              {dayjs(data?.date_of_installation).format('YYYY-MM-DD')
                ? dayjs(data?.date_of_installation).format('YYYY-MM-DD')
                : '-'}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SRBMTrapExpandable;
